<template>
  <div class="educational-material-box">
    <div>
      <portal to="educational-material-sidebar" class="position-relative">
        <div
          v-if="foldersLoading"
          class="position-absolute d-flex justify-content-center py-20 w-100"
        >
          <wtr-loader class="d-block" variant="primary" addText></wtr-loader>
        </div>
        <div :class="{ 'fetch-class': foldersLoading }">
          <folders
            v-if="folders"
            :selectedFolder="selectedFolder"
            :activeFolder="activeFolder"
            :foldersLoading="foldersLoading"
            :rootFolder="rootFolder"
            :folders="folders"
            :copiedFolder="copiedFolder"
            :disableActions="true"
            @selected="folderSelected"
            @cut-action="cutEducationalAction"
            @get-folders="getFolders()"
            @reset="resetEducationalFolders()"
            @temp-selected="selectedFolder = $event"
          ></folders>
        </div>
      </portal>
      <b-card no-body hide-footer>
        <div slot="header" class="fs-16 text-light" style="padding: 2px 0px">
          <div class="d-flex justify-content-between">
            <span>
              <breadcrumbs v-if="typeof crumbs === 'object'" :items="crumbs" />
              <span v-else>{{ crumbs }}</span>
            </span>
          </div>
        </div>
        <b-card-body class="position-relative">
          <educational-material-box
            :currentFolder="currentFolder"
            :key="currentFolderKey"
            @folder-changed="handleFolderChange"
            @material-saved="handleMaterialSaved"
            @view-responses="handleViewResponses"
            @refresh-folders="refreshFolders"
          ></educational-material-box>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// Mixins
import { EducationalMaterialMixin } from "../../../mixins/mixins";

// Components
import BreadcrumbsComponent from "../../../components/common/breadcrumbs.vue";
import EducationalFoldersComponent from "../components/folders.vue";
import EducationalMaterialBoxComponent from "../components/educational-material-box.vue";
import * as roleTypes from "../../../constants/constants-role";

export default {
  name: "MyEducationalMaterial",
  data() {
    return {
      ...roleTypes,
      isFoldersLoaded: false,
      listLoading: false,
      paramsUtil: {},
      materials: [],
      currentFolder: null,
      currentFolderKey: 0,
      allFolders: [],
    };
  },
  components: {
    "educational-material-box": EducationalMaterialBoxComponent,
    folders: EducationalFoldersComponent,
    breadcrumbs: BreadcrumbsComponent,
  },
  mixins: [EducationalMaterialMixin],
  computed: {
    ...mapGetters({
      sidebar: "getSidebar",
      crumbs: "getCrumbs",
    }),
    cardBodyStyles() {
      const height = this.$dashboardHeight - 60;
      return this.$getCardBodyStyle(height);
    },
    folderId() {
      return this.$pathParams.id || 0;
    },
  },
  mounted() {
    this.init();
  },
  updated() {},
  methods: {
    ...mapActions(["renderSidebarAction", "sidebarAction"]),
    init() {
      this.renderSidebarAction("educational-material-sidebar");
      this.sidebarAction({ show: true, full: true });
      this.$setHeaderAction(
        this.$t("educationalmaterial.myEducationalMaterial")
      );
      this.getFolders();
    },
    getFolders() {
      const options = {
        userId: localStorage.getItem("userId"),
      };
      this.getAllEducationalFolders(options, (activeFolder) => {
        this.folderSelected(activeFolder);
      });
    },
    folderSelected(node) {
      if (!node || (node && node.folderType === "RESPONSEFROMRECIPIENTS"))
        return;
      console.log(node, "node");

      this.activeFolder = node;
      this.selectedFolder = node;
      this.$setHeaderAction(node.name);
      this.currentFolder = node;
      this.currentFolderKey += 1;
    },
    handleFolderChange() {
    },
    handleMaterialSaved() {
      if (this.isPublishedFolder(this.currentFolder)) {
        const unpublishedFolder = this.findUnpublishedFolder(this.folders);
        if (unpublishedFolder) {
          this.folderSelected(unpublishedFolder);
        }
      }
    },
    openResponseFromRecipientsFolder() {
      if (!this.folders || !Array.isArray(this.folders)) return;

      // Function to recursively find and open the RESPONSEFROMRECIPIENTS folder
      const openFolder = (folders) => {
        for (const folder of folders) {
          if (folder.folderType === "RESPONSEFROMRECIPIENTS") {
            // Set opened to true
            folder.opened = true;
            console.log("Opened RESPONSEFROMRECIPIENTS folder");
            return true;
          }

          // Check children
          if (folder.children && folder.children.length > 0) {
            const found = openFolder(folder.children);
            if (found) return true;
          }
        }
        return false;
      };

      openFolder(this.folders);

      this.folders = [...this.folders];
    },

    // Then update handleViewResponses to call this method:
    handleViewResponses({ systemIdNumber, assignmentDate, assignment }) {
      console.log("Handling view responses for:", {
        systemIdNumber,
        assignmentDate,
        assignment,
      });

      // First, open the RESPONSEFROMRECIPIENTS folder
      this.openResponseFromRecipientsFolder();

      // Create the expected folder name (e.g., "TH-ASN-0024_Jan 6_2026")
      const expectedFolderName = `${systemIdNumber}_${assignmentDate}`;

      console.log("Expected folder name:", expectedFolderName);

      // Find the matching child folder
      const targetFolder = this.findResponseChildFolder(
        systemIdNumber,
        assignmentDate
      );

      if (targetFolder) {
        console.log("Switching to folder:", targetFolder);
        this.highlightSelectedNode(targetFolder.name);
        setTimeout(() => {
          this.folderSelected(targetFolder);
        }, 100);
      } else {
        console.warn("Could not find matching folder for:", expectedFolderName);
        this.$toastr(
          "warning",
          `No responses folder found for ${systemIdNumber}`
        );
      }
    },
    highlightSelectedNode(folderName) {
    this.$nextTick(() => {
      // Find all tree-anchor elements
      const treeAnchors = document.querySelectorAll('.tree-anchor');
      treeAnchors.forEach(anchor => {
        // Remove existing selection
        anchor.classList.remove('tree-selected');
        
        // Check if this anchor contains the folder name
        const span = anchor.querySelector('span:nth-child(2)');
        if (span && span.textContent && span.textContent.trim() === folderName) {
          anchor.classList.add('tree-selected');
        }
      });
    });
  },
  refreshFolders() {
    const previousFolderId = this.currentFolder?.id || null;

    this.getFolders();

    // restore selection after reload
    this.$nextTick(() => {
      if (!previousFolderId || !this.folders) return;

      const findById = (folders) => {
        for (const f of folders) {
          if (f.id === previousFolderId) return f;
          if (f.children?.length) {
            const found = findById(f.children);
            if (found) return found;
          }
        }
        return null;
      };

      const restored = findById(this.folders);
      if (restored) {
        this.folderSelected(restored);
      }
    });
  },
  },
};
</script>

<style scoped lang="scss">
.card {
  position: initial !important;
}
</style>
